import { Component } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { GbgrundstueckService } from '../../../core/gb-api';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { LastRechtRootEntryVm, StandardrechtViewmodelService } from '../../../core/services/standardrecht-viewmodel.service';
import { ListLoaderInfiniteBuilder } from '../../../shared/components/list-loader/list-loader-infinite';
import { AppConfigService } from '../../../core/services/app-config.service';
import { TimepointService } from '../../../core/services/timepoint.service';
import { AbstractGrundstueckEntryFromRoute } from '../abstract-grundstueck-entry-from.route';
import { AppPermissionService } from 'app/core/services/app-permission.service';
import { map, tap } from 'rxjs/operators';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { StandardrechtTableComponent } from '../../../shared/widgets/standardrecht-table/standardrecht-table.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundstueck-anmerkungen-rubrik',
  templateUrl: './grundstueck-anmerkungen-rubrik.component.html',
  styleUrls: ['./grundstueck-anmerkungen-rubrik.component.scss'],
  imports: [RubrikComponent, StandardrechtTableComponent, TranslatePipe]
})
export class GrundstueckAnmerkungenRubrikComponent extends AbstractGrundstueckEntryFromRoute {
  loader: ListLoader<LastRechtRootEntryVm>;
  ersterfassungUebergeben: boolean;
  showLableNichtOeffentlicheAnmerkungen: boolean;

  private readonly CHUNK_SIZE = 5;
  private readonly PAGE_SIZE = undefined;
  private readonly CURRENT_PAGE = 1;

  constructor(
    private standardrechtViewmodelService: StandardrechtViewmodelService,
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    private permissionService: AppPermissionService,
    protected router: Router
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
  }

  protected loadData() {
    this.showLableNichtOeffentlicheAnmerkungen = !this.permissionService.hasPermission('ANZEIGE_NICHT_OEFFENTLICHE_ANMERKUNGEN');
    this.loader = this.createAnmerkungLoader();
  }

  private createAnmerkungLoader(): ListLoader<LastRechtRootEntryVm> {
    const observable = (offset: number, limit: number) => {
      return this.standardrechtViewmodelService.loadSichtByGrundstueckId(this.gsId, 'ANMERKUNG', offset, limit, this.subscriptions).pipe(
        tap((res) => (this.ersterfassungUebergeben = res.ersterfassungUebergeben)),
        map((res) => res.entries)
      );
    };
    const loader = ListLoaderInfiniteBuilder.builder<LastRechtRootEntryVm>()
      .setLookupItemFunc(observable)
      .setChunkSize(this.CHUNK_SIZE)
      .setPageSize(this.PAGE_SIZE)
      .setCurrentPage(this.CURRENT_PAGE)
      .setPublishItemsWhenAllLoaded(true)
      .build();
    this.addLoader(loader);
    return loader;
  }
}
